export default __webpack_public_path__ + "static/media/img--interiors-2.752ef78b.jpg";